import React from "react";
import { BoiTooltip } from "../../boi-tooltip/boi-tooltip";
import {
    StyledContainer,
    LabelContainer,
    FieldDescription,
    FieldError
} from "./styled/container";
import BoiReactMarkdown from "../../boi-markdown/boi-markdown";
import { ConditionalWrapper } from "../../theme/style-utils-coras-nua";

const fieldSets = [
    "boi_slider",
    "checkbox",
    "fileupload",
    "name",
    "sort-code",
    "time",
    "tos",
    "years_and_months_field"
];

const Container = ({
    label,
    type,
    id,
    error,
    showError,
    children,
    hidden,
    description,
    labelClass,
    visibility,
    cssClass,
    customTooltip,
    descriptionPlacement,
    isRequired,
    size,
    form = {},
    innerRef,
    errorOrder
}) => {
    if (visibility === "hidden") {
        return null;
    }

    const showDescription =
        description && !cssClass.includes("field-description-hide");
    const descriptionPosition =
        descriptionPlacement && descriptionPlacement === "below"
                ? "below"
                : "above";
    const showLabel = type !== "html" && label;
    const showTooltip =
        customTooltip &&
        hidden !== true &&
        !cssClass.includes("field-label-hide");
    const isInlineLayout = `${cssClass}`.includes("u-inline-layout");
    const isFieldSet = fieldSets.includes(type);

    return (
        <StyledContainer
            ref={innerRef}
            className={
                "field" +
                (cssClass ? ` ${cssClass}` : "") +
                (type === "hidden" ? " hide" : "") +
                (error ? " error" : "") +
                (size === "small"
                    ? " small"
                    : size === "medium"
                    ? " medium"
                    : "")
            }
            data-id={`${id}`}>
            <ConditionalWrapper
                condition={isFieldSet}
                wrapper={children => <fieldset>{children}</fieldset>}>
                <ConditionalWrapper
                    condition={isInlineLayout}
                    wrapper={children => (
                        <div className="inline-group">{children}</div>
                    )}>
                    {showLabel && (
                        <LabelContainer>
                            {isFieldSet ? (
                                <legend className={`field-label ${labelClass}`}>
                                    {label}
                                    {isRequired ? (
                                        ""
                                    ) : (
                                        <span className="optional">
                                            {" (optional)"}
                                        </span>
                                    )}
                                    {showTooltip && (
                                        <BoiTooltip
                                            id={`tooltip-${form.id}_${id}`}
                                            customTooltip={customTooltip}>
                                            {customTooltip}
                                        </BoiTooltip>
                                    )}
                                </legend>
                            ) : (
                                <>
                                    <label
                                        htmlFor={`${id}`}
                                        className={`field-label ${labelClass}`}
                                    >
                                        {label}
                                        {isRequired ? (
                                            ""
                                        ) : (
                                            <span className="optional">
                                                {" (optional)"}
                                            </span>
                                        )}
                                    </label>
                                    {showTooltip && (
                                        <BoiTooltip
                                            id={`tooltip-${form.id}_${id}`}
                                            customTooltip={customTooltip}>
                                            {customTooltip}
                                        </BoiTooltip>
                                    )}
                                </>
                            )}
                        </LabelContainer>
                    )}
                </ConditionalWrapper>
                {showDescription && descriptionPosition === "above" && (
                    <FieldDescription
                        className={`field-description-above`}>
                        <BoiReactMarkdown>
                            {description}
                        </BoiReactMarkdown>
                    </FieldDescription>
                )}
                {children}
                {showDescription && descriptionPosition === "below" && (
                    <FieldDescription
                        className={`field-description-below below`}>
                        <BoiReactMarkdown>
                            {description}
                        </BoiReactMarkdown>
                    </FieldDescription>
                )}
            </ConditionalWrapper>
            {error && showError && <FieldError style={{ order: errorOrder}} className="field-error">{error}</FieldError>}
        </StyledContainer>
    );
};

Container.defaultProps = {
    label: "",
    type: "",
    id: "",
    error: "",
    showError: true,
    children: "",
    hidden: "",
    description: "",
    labelClass: "",
    visibility: "",
    cssClass: "",
    customTooltip: "",
    descriptionPlacement: "",
    isRequired: "",
    size: "",
    form: {},
    innerRef: null,
    errorOrder: 5
};

export default Container;
